module.exports = __webpack_public_path__ + "static/img/zljsbg2-C-ShHaQC.bbdf539.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/zljsbg2-C-ShHaQC.png
// module id = 0cv5
// module chunks = 16